import HTTPServices from "../HTTPServices/httpService";

const measurementServices = {
  //(1)
  MeasurementDetailByOrderGUID: async function (orderID_GUID) {
    console.log(
      " api URL : ->> 'MeasurementDetailByOrderGUID' service called: orderID_GUID: " +
        orderID_GUID
    );
    let result = await HTTPServices.post(
      "Measurement/MeasurementDetailByOrderGUID",
      orderID_GUID
    );
    // debugger;
    console.log("retrun result --->" + JSON.stringify(result));
    return result;
  },
  //(2)
  save: function (customerObj) {
    // console.log("'customerServices' service called: save : " + customerObj);
    return HTTPServices.post("customer/save", customerObj);
  },

  saveMeasurementAndMeasurementDetails: function (savingObj) {
    console.log(
      "'saveMeasurementAndMeasurementDetails' service called : " + savingObj
    );
    return HTTPServices.post(
      "measurement/saveMeasurementAndMeasurementDetails",
      savingObj
    );
  },

  getAllCustomerMeasurementsByCustomerGUID: async function (customerGUID) {
    console.log(
      "'getAllCustomerMeasurementsByCustomerGUID' service called: " +
        customerGUID
    );
    let result = await HTTPServices.post(
      "measurement/getAllCustomerMeasurementsByCustomerGUID/",
      customerGUID
    );
    console.log("result got: " + JSON.stringify(result));
    return result;
  },

  //(3)
  // getOrderVMByCustomerID: async function (customerID) {
  //   console.log(
  //     "'getOrderVMByCustomerID' service called: customerID: " + customerID
  //   );
  //   let result = await HTTPServices.post(
  //     "customer/GetOrderVMByCustomerID",
  //     customerID
  //   );
  //   debugger;
  //   console.log("retrun result --->" + result);
  //   return result;
  // },
};

export default measurementServices;
